import { render } from "./Filter.vue?vue&type=template&id=395f1fb8&scoped=true"
import script from "./Filter.vue?vue&type=script&lang=js"
export * from "./Filter.vue?vue&type=script&lang=js"

import "./Filter.vue?vue&type=style&index=0&id=395f1fb8&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395f1fb8"]])

export default __exports__